import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '热门电影', path: '/category/movies' },
    { label: '最新电视剧', path: '/category/tv-series' },
    { label: '动漫番剧', path: '/category/anime' },
    { label: '综艺节目', path: '/category/variety' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '用户口碑', path: '/about#reputation' },
    { label: '联系我们', path: '/about#contact' },
    { label: '常见问题', path: '/#faq' },
  ],
  影视分类: [
    { label: '动作片', path: '/category/movies' },
    { label: '喜剧片', path: '/category/movies' },
    { label: '科幻片', path: '/category/movies' },
    { label: '爱情片', path: '/category/movies' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-700/30">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 mb-4 whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-xl font-bold text-foreground-50">
                夜猫电影院
              </span>
            </Link>
            <p className="text-foreground-600 text-sm leading-relaxed max-w-sm">
              夜猫电影院专为夜间追剧打造，免费在线观看高清电影、电视剧，不缓冲不卡顿。午夜剧场海量片源，满足你的夜猫子观影需求。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-bilibili-line', 'ri-vidicon-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-500 hover:text-primary-500 hover:bg-background-800 transition-all cursor-pointer"
                  rel="nofollow"
                  aria-label={icon.replace('ri-', '').replace('-line', '')}
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-foreground-200 text-sm font-semibold mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-foreground-600 hover:text-primary-500 text-sm transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-700/30 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-700 text-xs">
            &copy; {new Date().getFullYear()} 夜猫电影院. 版权所有.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-700 hover:text-foreground-400 text-xs transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-foreground-700 hover:text-foreground-400 text-xs transition-colors" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-foreground-700 hover:text-foreground-400 text-xs transition-colors" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}